import { Link } from "react-router-dom";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";
import { Heart, ScrollText, Sparkles, Sun, Users, HandHeart, RefreshCcw, Award, MapPin, Home } from "lucide-react";

const ICONS = [Heart, ScrollText, Sparkles, Sun, Users, HandHeart, RefreshCcw, Award, MapPin, Home];

const LINKS = {
  1: "/casamento-religioso-com-efeito-civil",
  2: "/cerimonia-de-casamento-personalizada",
  3: "/casamento-em-sitio-chacara-fazenda",
  9: "/casamento-em-sitio-chacara-fazenda",
};

export default function Modalities() {
  const { content } = useSite();
  const modalities = content?.modalities || [];
  if (!modalities.length) return null;

  return (
    <section id="cerimonias" className="py-20 lg:py-28 bg-cream" data-testid="modalities-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>Modalidades de cerimônia</Eyebrow>
            <SectionTitle>Uma celebração para cada história</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {modalities.map((m, i) => {
            const Icon = ICONS[i % ICONS.length];
            const link = LINKS[i];
            const inner = (
              <>
                <div className="w-11 h-11 rounded-full bg-sand flex items-center justify-center text-golddark group-hover:bg-gold group-hover:text-white transition-colors duration-500">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 text-xl font-serif text-ink leading-snug">{m.title}</h3>
                <p className="mt-2 text-sm font-light text-cocoa leading-relaxed">{m.text}</p>
                {link && (
                  <span className="mt-3 inline-block text-xs font-semibold uppercase tracking-[0.15em] text-golddark">
                    Saiba mais →
                  </span>
                )}
              </>
            );
            const cls =
              "group block bg-warmwhite border border-gold/20 rounded-2xl p-6 sm:p-8 h-full hover:border-gold/50 hover:shadow-xl hover:shadow-gold/10 hover:-translate-y-1 transition-all duration-500";
            return (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                {link ? (
                  <Link to={link} className={cls} data-testid={`modality-card-${i}`}>
                    {inner}
                  </Link>
                ) : (
                  <div className={cls} data-testid={`modality-card-${i}`}>
                    {inner}
                  </div>
                )}
              </Reveal>
            );
          })}
        </div>

        {content?.civil_note && (
          <Reveal delay={0.2}>
            <div className="mt-10 bg-sand border-l-4 border-gold rounded-r-2xl p-6 sm:p-8" data-testid="civil-note">
              <p className="text-sm sm:text-base font-light text-cocoa leading-relaxed">
                <span className="font-semibold text-olive">Importante — </span>
                {content.civil_note}{" "}
                <Link to="/casamento-religioso-com-efeito-civil" className="font-semibold text-golddark hover:underline" data-testid="civil-note-link">
                  Saiba como funciona o casamento religioso com efeito civil.
                </Link>
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
